module.exports = __webpack_public_path__ + "res/img_other_action_negative.93a3e3079c8478e1177841ae8d0cb02e.png";